var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "callout",
    {
      staticClass: "mb-4",
      attrs: {
        "border-color": "primary-2",
        controlled: true,
        "has-toggle": false
      }
    },
    [
      _c(
        "validation-observer",
        { ref: "formValidator" },
        [
          _c("icon-view", {
            staticClass: "icon-view__extended",
            attrs: {
              icon: "fas fa-file-plus",
              "icon-background": "#FF7058",
              "icon-color": "#fff",
              "icon-size": "18px",
              title: "Razón de Addendum"
            }
          }),
          _c("div", { staticClass: "row mt-3" }, [
            !_vm.readOnly
              ? _c(
                  "div",
                  { staticClass: "col d-flex align-items-end" },
                  [
                    _c("custom-drop-down", {
                      staticClass: "w-30",
                      attrs: {
                        clearable: false,
                        fieldkey: "id",
                        fieldname: "name",
                        label: "Razón:",
                        options: _vm.addendumReasonsOptions,
                        placeholder: "Seleccione"
                      },
                      model: {
                        value: _vm.reasonSelected,
                        callback: function($$v) {
                          _vm.reasonSelected = $$v
                        },
                        expression: "reasonSelected"
                      }
                    }),
                    _c(
                      "action-button",
                      {
                        staticClass: "ml-2",
                        attrs: { i: "fas fa-file-plus", variant: "success" },
                        on: {
                          click: function($event) {
                            return _vm.addReason()
                          }
                        }
                      },
                      [_vm._v(" Añadir ")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("custom-chips-group", {
                  staticClass: "mt-n3",
                  attrs: {
                    disabled: _vm.readOnly,
                    "no-background": "",
                    "no-wrap": true,
                    "object-text": "name",
                    "on-item-deleted": _vm.onDeleteItemHandler,
                    "selected-items": _vm.model.addendumReasons,
                    title: "Razón(es) Seleccionada(s):"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "custom-error-msg": "Favor completar comentario.",
                              disabled: _vm.readOnly,
                              error: errors[0],
                              label: "Comentario:",
                              maxlength: 3000,
                              name: "comment",
                              rows: 3
                            },
                            model: {
                              value: _vm.model.comment,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "comment", $$v)
                              },
                              expression: "model.comment"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            !_vm.readOnly
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col mt-3 mb-3 d-flex align-items-end justify-content-end"
                  },
                  [
                    _c(
                      "action-button",
                      {
                        attrs: {
                          i: "fas fa-times-circle",
                          variant: "btn btn-outline-danger btn-cancel danger"
                        },
                        on: { click: _vm.handleCancel }
                      },
                      [_vm._v(" Cancelar ")]
                    ),
                    _c(
                      "action-button",
                      {
                        staticClass: "ml-3",
                        attrs: {
                          i: "far fa-arrow-circle-right",
                          variant: "success"
                        },
                        on: { click: _vm.handleContinue }
                      },
                      [_vm._v(" Continuar ")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }